import { render, staticRenderFns } from "./MessageFiles.vue?vue&type=template&id=7658673c"
import script from "./MessageFiles.vue?vue&type=script&lang=js"
export * from "./MessageFiles.vue?vue&type=script&lang=js"
import style0 from "./MessageFiles.vue?vue&type=style&index=0&id=7658673c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports